import React from 'react';

import styles from './OrderSummaryCard.module.scss';

interface OrderSummaryItemComponentProps {
  title: string;
  value: string;
}

export const OrderSummaryItemComponent: React.FC<OrderSummaryItemComponentProps> = ({ title, value }) => (
  <div className={styles.summary_item}>
    <span className={styles.title}>{title}</span>
    <span>{value}</span>
  </div>
);
